import { Button, Stack, TextField, Typography } from '@mui/material'
import type { Relation } from '@mynt/backoffice-api-spec/templates'
import { useState } from 'react'
import {
  type CreateRelationRequest,
  type EditorChangeRequest,
  EditRelationOperation,
  type RelationId,
  type RelationTemplate,
} from '../api/api'
import { RelationEditor } from '../components/RelationEditor'

interface RelationEditorProps {
  onChange: (changeRequests: EditorChangeRequest[]) => void
  relation: Relation
  templates: RelationTemplate[]
  requests: EditorChangeRequest[]
}

export interface RelationDetailsProps {
  relation: Relation | undefined
  templates: RelationTemplate[] | undefined
  onSaveChanges?: (changeRequests: EditorChangeRequest[]) => Promise<void>
  isLoading: boolean
  slots: { Editor: React.ComponentType<RelationEditorProps> }
}

interface CreateRelationFormProps {
  onCreateRelation: (relation: CreateRelationRequest) => Promise<void>
  templates: RelationTemplate[]
  isCreating: boolean
}

export const CreateRelationForm = ({ onCreateRelation, templates, isCreating }: CreateRelationFormProps) => {
  const [changeRequests, setChangeRequests] = useState<EditorChangeRequest[]>([])
  const [name, setName] = useState('')

  const handleSave = () => {
    const relativeAddChangeRequests = changeRequests.filter(
      (request) => request.type === 'relative' && request.op === EditRelationOperation.ADD,
    )

    const relatives = relativeAddChangeRequests.map((request) => request.relative.id)

    const newRelation: CreateRelationRequest = {
      name: name,
      relatives,
    }

    onCreateRelation(newRelation)
  }

  const isValid = name.trim() !== '' && changeRequests.length > 0

  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <Typography variant="h2">Create relation</Typography>
      <TextField placeholder="Relation name" value={name} onChange={(e) => setName(e.target.value)} />
      <RelationEditor
        onChange={setChangeRequests}
        relation={{ id: '' as RelationId, name: '', relatives: [], allowedPaths: [] }}
        templates={templates}
        requests={changeRequests}
        showAllowedPaths={false}
      />
      <Stack
        sx={{
          alignItems: 'flex-end',
        }}
      >
        <Button disabled={!isValid} loading={isCreating} variant="contained" onClick={handleSave}>
          Create relation
        </Button>
      </Stack>
    </Stack>
  )
}
